export function LoadingDots({ className }: { className?: string }) {
  return (
    <span className={className ?? 'inline-flex items-center gap-0.5'}>
      <span className="animate-bounce" style={{ animationDelay: '0ms' }}>
        .
      </span>
      <span className="animate-bounce" style={{ animationDelay: '150ms' }}>
        .
      </span>
      <span className="animate-bounce" style={{ animationDelay: '300ms' }}>
        .
      </span>
    </span>
  );
}
